export const FORMAT = {
  DATE_YEAR: "MMM dd', 'yyyy",
  FULL_TIME: 'PP pp',
} as const;
